<template>
    <div>
        <helpInfo :helpData="helpData"></helpInfo>
        <div style="padding: 15px">
            <div style="padding:0px;">
                <div class="container">
                    <rcTable ref="rcTable"
                             :tableAttr="tableAttr">
                        <Button @click="refreshTable"
                                class="tootip-btn"
                                slot="tootipL">
                            <i class="icon-refresh-o-2"></i>
                        </Button>
                        <div slot="tootipR">
                            <DatePicker v-model="newDate"
                                        type="datetimerange"
                                        :dateOptions="dateOptions"
                                        :clearable="false"
                                        :editable='false'
                                        placement="bottom-end"
                                        :placeholder="$t('公告时间')"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        @on-ok="dateChange"
                                        @on-clear="dateClear"
                                        transfer
                                        style="width: 355px"></DatePicker>
                        </div>
                    </rcTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import helpInfo from '@c/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api.js'
import { formatDateTime } from '@/service/utils'
export default {
    name: 'announcementList',
    components: {
        helpInfo,
        rcTable
    },
    data () {
        return {
            helpData: {
                modelName: '公告消息'
            },
            newDate: [], // new Date(new Date() - 24 * 60 * 60 * 1000), new Date()
            dateOptions: {
                shortcuts: [
                    {
                        text: '1' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 1)
                            return [start, end]
                        }
                    },
                    {
                        text: '12' + this.$t('小时'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 12)
                            return [start, end]
                        }
                    },
                    {
                        text: '1' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            return [start, end]
                        }
                    },
                    {
                        text: '7' + this.$t('天'),
                        value () {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            return [start, end]
                        }
                    }
                ]
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_NOTICE_LIST, false),
                    params: {}
                },
                searchShow: true,
                tableSearchKey: 'announcementTable', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: 'announcementTable', // 当作列选择的key存在
                referenceVal: 930,
                searchColumns: [
                    {
                        title: this.$t('公告标题'),
                        key: 'noticeTitle'
                    },
                    {
                        key: 'noticeTypeId',
                        title: this.$t('公告类型'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: []
                    }
                ],
                columns: [
                    {
                        title: this.$t('序号'),
                        key: 'sn',
                        columnShow: true,
                        sortable: false,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 50,
                        resizable: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.sn } }, params.row.sn)
                        }
                    },
                    {
                        title: this.$t('公告标题'),
                        key: 'noticeTitle',
                        columnShow: true,
                        sortable: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 250,
                        render: (h, params) => {
                            return h(this.hasPermission('CF08') ? 'a' : 'span', {
                                class: 'link',
                                on: {
                                    click: () => {
                                        this.hasPermission('CF08') && this.showDetail(params.row)
                                    }
                                }
                            }, params.row.noticeTitle)
                        }
                    },
                    {
                        title: this.$t('公告类型'),
                        key: 'noticeTypeName',
                        columnShow: true,
                        sortable: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        width: 200,
                        resizable: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.noticeTypeName } }, params.row.noticeTypeName)
                        }
                    },
                    {
                        title: this.$t('公告时间'),
                        key: 'publishDt',
                        columnShow: true,
                        sortable: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        minWidth: 160,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.publishDt } }, params.row.publishDt)
                        }
                    }
                ]
            }
        }
    },
    created () {
        this.getType()
    },
    methods: {
        getType () {
            this.axios.get(this.urlFormat(API.GET_NOTICETYEP_ALL, false)).then(res => {
                for (const i in this.tableAttr.searchColumns) {
                    if (res && res.length > 0 && this.tableAttr.searchColumns[i].key === 'noticeTypeId') {
                        this.tableAttr.searchColumns[i].searchData = res.map(item => {
                            return {
                                value: item.noticeTypeId,
                                name: this.$t(item.noticeTypeName)
                            }
                        })
                    }
                }
            })
        },
        // 刷新
        refreshTable (data) {
            this.$refs.rcTable && this.$refs.rcTable.refreshTable(data, true)
        },
        dateChange () {
            // 选择时间
            this.refreshTable(Object.assign(this.tableAttr.source.params, {
                publishStartDate: this.newDate[0] ? formatDateTime(this.newDate[0]) : null,
                publishEndDate: this.newDate[1] ? formatDateTime(this.newDate[1]) : null
            }))
        },
        dateClear () {
            this.newDate = [null, null]
            this.dateChange()
        },
        showDetail (rowData) {
            this.$router.push({
                path: `/mgt/msgs/${rowData.noticeId}`,
                query: {
                    id: rowData.noticeId
                }
            })
        }
    }
}
</script>
